<script setup lang="ts">
import { computed } from 'vue';
import { STATUS_CLOSED, STATUS_OPEN } from '@/constants';
import ToggleSwitch from 'primevue/toggleswitch';

interface Props {
  title?: string;
  status?: string;
}
const props = defineProps<Props>();

const emits = defineEmits<{ 'update:status': [value: any] }>();

const statusValue = computed({
  get() {
    return props.status;
  },
  set(value) {
    emits('update:status', value);
  }
});
</script>

<template>
  <div>
    <div class="city-status flex">
      <label :for="title">{{ title }}</label>
      <ToggleSwitch class="ml-2" :id="title" v-model="statusValue" :trueValue="STATUS_OPEN" :falseValue="STATUS_CLOSED" />
    </div>
  </div>
</template>
